<template>
    <span class="inline ml-2">
        {{this.min}}:{{this.sec}}
    </span>
</template>

<script>
    export default {
        name: "Timer",
        data() {
            return {
                now : new Date(),
                timer : null
            }
        },
        props : {
            endDate : {  // pass date object till when you want to run the timer
                type : Date,
                default() {
                    var dt = new Date();
                    dt.setSeconds( dt.getSeconds() + 180);
                    return dt
                }
            },
        },
        computed:{
            min(){
                let m = Math.trunc((this.endDate - this.now) / 1000 / 60) % 60;
                return m>9?m:'0'+m;
            },
            sec(){
                let s = Math.trunc((this.endDate - this.now)/1000) % 60
                return s>9?s:'0'+s;
            }
        },
        watch: {
            endDate : {
                immediate : true,
                handler(newVal){
                    if(this.timer){
                        clearInterval(this.timer)
                    }
                    this.timer = setInterval(()=>{
                        this.now = new Date()
                        if(this.negative)
                            return

                        if(this.now > newVal){
                            this.now = newVal
                            this.$emit('endTime')
                            clearInterval(this.timer)
                        }
                    }, 1000)
                }
            }
        },
        beforeDestroy(){
            clearInterval(this.timer)
        }
    }
</script>

<style scoped>

</style>